import { useSearchParams } from 'react-router-dom'
import { formatInTimeZone } from 'date-fns-tz'
import { Page } from '../layout'
import { Loading } from 'ui'
import { useCompanyInfo } from 'queries/company'
import { useUpcomingInvoiceDetail } from 'queries/payment'
import { UpcomingInvoiceDetails } from './UpcomingInvoiceDetails'

const DEFAULT_WEEK_TIMEZONE = 'America/Los_Angeles'
const DATE_FORMAT = 'MM/dd/yyyy zzz'

export function UpcomingInvoiceDetailPage() {
  const [searchParams] = useSearchParams()
  const periodStart = searchParams.get('periodStart') ?? undefined
  const invoiceGroupKey = searchParams.getAll('invoiceGroupKey')
  const { data: company } = useCompanyInfo()
  const { data: detail, isLoading } = useUpcomingInvoiceDetail({
    companyId: company?.id,
    periodStart,
    invoiceGroupKey,
  })

  const weekTimezone = detail?.weekTimezone || DEFAULT_WEEK_TIMEZONE
  const title = detail
    ? `Estimated charges for ${formatInTimeZone(
        new Date(detail.periodStart),
        weekTimezone,
        DATE_FORMAT
      )} – ${formatInTimeZone(
        new Date(detail.periodEnd),
        weekTimezone,
        DATE_FORMAT
      )}`
    : 'Loading...'

  return (
    <Page title={title}>
      {isLoading ? <Loading /> : null}
      {detail ? <UpcomingInvoiceDetails data={detail} /> : null}
    </Page>
  )
}
